module.exports = __webpack_public_path__ + "img/welcome-l.a701684b.jpg";